import React, { useEffect } from 'react';
import tsRest from 'ts-rest-client';
import { ProductSuggestionModel } from '../../../tsrestapi/models';
import { ProductSuggestion } from './product-suggestion';
import { PleaseWaitSpinner } from '../../../../jsxctl/utilctl';
import { useDeepUnchanged } from '../../../logic/hooks/use-deep-unchanged';

type ProductSuggestionListProps = {
    eventIds: number[],
    onAddProduct: (eventId: number, amount: number) => any,
    cartResponse: any
};

export function ProductSuggestionList({eventIds, onAddProduct, cartResponse}: ProductSuggestionListProps) {
    const [products, setProducts] = React.useState<ProductSuggestionModel[]>([]);
    const [loading, setLoading] = React.useState<boolean>(true);

    const stableEventIds = useDeepUnchanged(eventIds);
    useEffect(() => {(async () => {
        const products = await tsRest.post("productsuggestions", { eventIds: stableEventIds });

        setProducts(products);

        setLoading(false);
    })();}, [stableEventIds]);

    return (loading ? <PleaseWaitSpinner /> : products.length > 0 && (
            <div className='product-suggestion-list'>
                {products.map((product) => 
                    <ProductSuggestion
                        key={product.eventId} 
                        productSuggestion={product} 
                        onAddProduct={onAddProduct}
                        cartResponse={cartResponse}
                    />)}
            </div>
        )
    );
}